import { Injectable } from "@angular/core";
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from "@angular/router";
import { Auth } from "aws-amplify";
import { BaseUserService } from "@smarterplan/ngx-smarterplan-core";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private userService: BaseUserService) { }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean | UrlTree> {
        if (!this.userService.cu) {
            // console.log("first connection auth guard");
            let cau = null;
            let user = null;
            try {
                cau = await Auth.currentAuthenticatedUser();
                user = await this.userService.current(cau);
            } catch { }
            if (!user) {
                this.router.navigate(["connect"]);
                return false;
            }
            return true;
        }
        return true;
    }
}
